import { tokenizersApi } from '../api/smartTokenizerApi';
import { CUSTOM_TOKENIZER_CONTRACT_TEMPLATE_ID } from './standardContractTemplates';
import { sanitizeContractName } from './offlineSigning';

function deriveSymbolFromAssetClass(ac) {
  if (ac?.marketSymbol && String(ac.marketSymbol).trim()) {
    return String(ac.marketSymbol).trim().slice(0, 12);
  }
  const code = String(ac?.code || '').replace(/[^A-Za-z0-9]/g, '').toUpperCase();
  return (code.slice(0, 6) || 'RWA').slice(0, 12);
}

/**
 * Constructor args for RwaSharedSeriesErc721: (string name, string symbol, address[] initialMinters).
 * Those addresses are **operators** for both mint and burn on the reference CBC721 artifact.
 *
 * Preloaded CBC20 / CBC1155 use the same three constructor args. For ERC-777 / ERC-4626 / ERC-3525 or other
 * custom bytecode, mirror the same idea
 * (one owner + `minters(address)` or `operators(address)` + `setMinter`/`setOperator`) so the API can
 * enforce catalog access consistently.
 */
export async function buildSharedSeries721ConstructorParameters({
  contractTemplateId,
  isAdmin,
  isPlatformStandard,
  assetClass,
  contractName
}) {
  if (contractTemplateId === CUSTOM_TOKENIZER_CONTRACT_TEMPLATE_ID) {
    return [];
  }
  const name = sanitizeContractName(contractName || `${assetClass?.name || 'RWA'}NFT`);
  const symbol = deriveSymbolFromAssetClass(assetClass);
  let minters = [];
  if (isAdmin && isPlatformStandard) {
    try {
      const { data } = await tokenizersApi.list();
      const list = Array.isArray(data) ? data : [];
      const approved = list.filter((t) => {
        const st = t.status ?? t.Status;
        return String(st) === 'Approved' && String(t.walletAddress || t.WalletAddress || '').trim();
      });
      const seen = new Set();
      for (const t of approved) {
        const w = String(t.walletAddress || t.WalletAddress || '').trim();
        const low = w.toLowerCase();
        if (seen.has(low)) continue;
        seen.add(low);
        minters.push(w);
      }
    } catch {
      minters = [];
    }
  }
  return [name, symbol, JSON.stringify(minters)];
}
